"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customizeOutcomeNameWithoutTemplate = exports.customizeOutcomeName = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const renderMustacheTemplate_1 = require("../renderMustacheTemplate");
const isParameterValueMatching_1 = require("../../isParameterValueMatching");
const customizeOutcomeName = ({ eventProbability, market, eventCompetitors, isShortNamed, players, outcomeTypeName, }) => {
    var _a;
    const { homeCompetitors, awayCompetitors } = eventCompetitors;
    const homeCompetitorNames = homeCompetitors.map((c) => c.name).join(', ');
    const awayCompetitorNames = awayCompetitors.map((c) => c.name).join(', ');
    const data = {
        outcomeTypeName,
        competitor1: homeCompetitorNames,
        competitor2: awayCompetitorNames,
    };
    eventProbability.parameters.forEach((param) => {
        data[param.type] = param.value;
    });
    const playerId = data[betweb_openapi_axios_1.ParameterType.PlayerId];
    const player = players[playerId];
    data.playerName = (player === null || player === void 0 ? void 0 : player.name) || '';
    let customName = '';
    let isCustomized = false;
    (_a = market.outcomeCustomizations) === null || _a === void 0 ? void 0 : _a.forEach((customization) => {
        const matchOutcomeTypeId = isMatchOutcomeTypeId(eventProbability, customization.filteredBy);
        const matchParameters = isMatchParameters(eventProbability, customization.filteredBy);
        if (matchOutcomeTypeId && matchParameters) {
            const template = isShortNamed
                ? customization.shortName
                : customization.name;
            if (template) {
                customName = (0, renderMustacheTemplate_1.renderMustacheTemplate)(template, data);
                isCustomized = true;
            }
        }
    });
    return { customName, isCustomized };
};
exports.customizeOutcomeName = customizeOutcomeName;
const customizeOutcomeNameWithoutTemplate = ({ eventProbability, market, isShortNamed, }) => {
    var _a;
    let customName = '';
    let isCustomized = false;
    (_a = market.outcomeCustomizations) === null || _a === void 0 ? void 0 : _a.forEach((customization) => {
        const matchOutcomeTypeId = isMatchOutcomeTypeId(eventProbability, customization.filteredBy);
        const matchParameters = isMatchParameters(eventProbability, customization.filteredBy);
        if (matchOutcomeTypeId && matchParameters) {
            const template = isShortNamed
                ? customization.shortName
                : customization.name;
            if (template) {
                customName = template;
                isCustomized = true;
            }
        }
    });
    return { customName, isCustomized };
};
exports.customizeOutcomeNameWithoutTemplate = customizeOutcomeNameWithoutTemplate;
const isMatchOutcomeTypeId = (eventProbability, filteredBy) => {
    if (!(filteredBy === null || filteredBy === void 0 ? void 0 : filteredBy.outcomeTypeId))
        return true;
    return eventProbability.outcomeTypeId === filteredBy.outcomeTypeId;
};
const isMatchParameters = (eventProbability, filteredBy) => {
    if (!(filteredBy === null || filteredBy === void 0 ? void 0 : filteredBy.parameters))
        return true;
    if (filteredBy.parameters.length === 0)
        return true;
    return filteredBy.parameters.every((filterParameter) => eventProbability.parameters.some((pParameter) => (0, isParameterValueMatching_1.isParameterValueMatching)(pParameter, filterParameter)));
};
//# sourceMappingURL=customizeOutcomeName.js.map